import { FilterOption } from "./libraryTypes";
import { flattenCategoryTree } from "./filterUtils";

export const QUICK_CATEGORY_PRESETS: {
  key: string;
  terms: string[];
}[] = [
  { key: "rug", terms: ["Area Rugs", "Rug"] },
  {
    key: "ceilingLight",
    terms: ["Ceiling", "Ceiling lights", "Ceiling light", "Lighting"],
  },
  { key: "coffeeTable", terms: ["Coffee tables", "Coffee table"] },
  { key: "sofa", terms: ["Sofas", "Sofa"] },
  { key: "loungeChair", terms: ["Lounge chairs", "Lounge chair"] },
  { key: "plant", terms: ["Plants"] },
  { key: "flowerPot", terms: ["Flower Pots", "Flower pot"] },
  { key: "bed", terms: ["Beds", "Bed"] },
  {
    key: "tableLamp",
    terms: ["Table lamps", "Table lamp", "Bordslampa"],
  },
  { key: "vase", terms: ["Vases", "Vase", "Vas"] },
  {
    key: "cushions",
    terms: [
      "Decorative Pillows & pillow cases",
      "Decorative pillows",
      "Pillow cases",
      "Kuddar",
    ],
  },
  { key: "curtain", terms: ["Curtains", "Curtain", "Gardin"] },
  { key: "mirror", terms: ["Mirrors", "Mirror", "Spegel"] },
];

/**
 * Rough singularization so "Coffee tables" and "Coffee table" compare equal,
 * without letting short words like "table" match the full phrase.
 */
const singularizeToken = (token: string): string => {
  if (token.endsWith("ies") && token.length > 3) {
    return `${token.slice(0, -3)}y`;
  }
  if (token.endsWith("sses")) {
    return token.slice(0, -2);
  }
  if (
    token.endsWith("s") &&
    !token.endsWith("ss") &&
    !token.endsWith("us") &&
    token.length > 2
  ) {
    return token.slice(0, -1);
  }
  return token;
};

export const normalizeQuickCategoryName = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean)
    .map(singularizeToken)
    .join(" ");

/**
 * Exact name match only (after light plural/ampersand normalization).
 * Avoids substring matches like term "Coffee table" → category "table".
 */
export const namesMatch = (categoryName: string, term: string): boolean =>
  normalizeQuickCategoryName(categoryName) ===
  normalizeQuickCategoryName(term);

/**
 * Keep a popular-category pill only when the 3D-scoped category list has a
 * matching name. Empty catalogs therefore hide every pill.
 */
export const matchQuickCategories = (categories: FilterOption[]) => {
  const flat = flattenCategoryTree(categories);
  return QUICK_CATEGORY_PRESETS.map((preset) => ({
    ...preset,
    matches: flat.filter((category) =>
      preset.terms.some((term) => namesMatch(category.name, term)),
    ),
  })).filter((preset) => preset.matches.length > 0);
};
